import axiosInstance from "../api/axiosInstance";

export interface Template {
  id: number;
  slug: string;
  name: string;
  description: string;
  tags: string[];
  content: string;
}

export interface TemplatePageParams {
  offset?: number;
  page_size?: number;
  search?: string;
}

export interface TemplatePageResponse {
  results: Template[];
  hasMore: boolean;
  next_offset: number | null;
}

export const getTemplates = async (): Promise<Template[]> => {
  const response = await axiosInstance.get("/templates/templates/");
  return response.data;
};

// Paginated + searchable variant of the same endpoint. Passing params switches the backend from
// the legacy plain array to {results, hasMore, next_offset}. `signal` lets callers cancel a stale
// in-flight search (AbortController) so an out-of-order response can't repaint the wrong list.
export const getTemplatesPaged = async (
  params: TemplatePageParams = {},
  signal?: AbortSignal,
): Promise<TemplatePageResponse> => {
  const response = await axiosInstance.get("/templates/templates/", { params, signal });
  return response.data;
};

export const getTemplateBySlug = async (slug: string): Promise<Template> => {
  const response = await axiosInstance.get(`/templates/templates/${slug}/`);
  return response.data;
};

export const addCustomTemplates = async (templates: {
  template_ids: number[];
}): Promise<void> => {
  await axiosInstance.post("/templates/custom/", templates);
};
